// extracted by mini-css-extract-plugin
export var divider = "_we-0";